// src/components/auth/AuthAlert.tsx
import React from "react";

export default function AuthAlert({ message }: { message: string }) {
  if (!message) return null;

  return (
    <div
      style={{
        padding: "15px",
        marginBottom: "20px",
        border: "1px solid transparent",
        borderRadius: "4px",
        color: "#721c24",
        backgroundColor: "#f8d7da",
        borderColor: "#f5c6cb",
        alignItems: "center",
        textAlign: "center",
      }}
      role="alert"
    >
      {message}
    </div>
  );
}